export const ORGANOGRAM_PAGE_LIMIT = 10
